export default __webpack_public_path__ + "static/nextjs-4020a4f0e919c14870dbd01d6145af37.svg";